module.exports = __webpack_public_path__ + "static/media/cover1.02835f1f.jpeg";